/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Edit_Contract_Start_HintInputs */



/**
* | output |
* | --- |
* | "Changing this also moves the customer's billing day." |
*
* @param {Partner_Edit_Contract_Start_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_start_hint = /** @type {((inputs?: Partner_Edit_Contract_Start_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_Start_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Änderung verschiebt auch den Abrechnungstag des Kunden.")
	return /** @type {LocalizedString} */ ("Changing this also moves the customer's billing day.")
});